import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-sec002-card-III',
  templateUrl: './sec002-card-III.component.html'
})

export class Sec002CardIIIComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;
  public readOnlyMtvEspDebulha?: boolean;

  public listOptionsMotvEspDebulha?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listOptionsMotvEspDebulhaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listOptionsLinDeb?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listOptionsLinDebOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraTopo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraTopoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraFundo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraFundoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public filterOptionsMotvEspDebulha?: Observable<DropDownListDTO[]>;
  public filterOptionsLinDeb?: Observable<DropDownListDTO[]>;

  @Output() mkCalc = new EventEmitter();
  @Output() reqSecagem = new EventEmitter();

  @Input() isRessect: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
    super('', false);
    if (this.isComercial || this.isBasica) {
      this.formulario = this.formBuilder.group({
        Inicio_debulha_data: [null, [Validators.pattern(this.regexDate)]],
        Inicio_debulha_hora: [null, [Validators.pattern(this.regexHour)]],
        Termino_debulha_data: [null, [Validators.pattern(this.regexDate)]],
        Termino_debulha_hora: [null, [Validators.pattern(this.regexHour)]],
        Motivo_espera_debulha: [null, []],
        Umidade_minima: [null, []],
        Umidade_maxima: [null, []],
        Umidade_debulha_media: [null, []],
        Desvio_padrao: [null, []],
        Peneira_topo_utilizada: [null, []],
        Retido_na_peneira_topo: [null, []],
        Peneira_fundo_utilizada: [null, []],
        Vazado_na_peneira_fundo: [null, []],
        Linha_da_debulha: [null, []],
      });
    } else {
      this.formulario = this.formBuilder.group({});
    }

  }

  public async ngOnInit(): Promise<void> {
    this.readOnlyMtvEspDebulha = true;
    await this.getLists();
    await this.getFilters();

    this.step = this.isPreBasica ? 'Tempos de atividades' : 'Debulha'
    await this.requiredSecagem();
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }
  async requiredSecagem(): Promise<void> {

    this.reqSecagem.emit();
  }

  async getLists(): Promise<void> {
    await this.getListOptionMotvEspDebulha();
    await this.getListOptionLinDeb();
    await this.getListPeneiraTopo();
    await this.getListPeneiraFundo();
  }

  async getFilters(): Promise<void> {
    // await this.createFilterMotvEspDebulha();
    await this.createFilterLinDeb();
    await this.createFilterListPeneira();
    await this.createFilterListPeneiraFundo();

  }

  private async createFilterLinDeb(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listOptionsLinDebOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listOptionsLinDeb = this.listOptionsLinDebOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listOptionsLinDeb = this.listOptionsLinDebOriginal;
      }
    } else {
      this.listOptionsLinDeb = this.listOptionsLinDebOriginal;
    }
    // this.filterOptionsLinDeb = this.formulario.get('Linha_da_debulha').valueChanges
    //     .pipe(
    //         startWith(''),
    //         map(value => this.generalService._filterDropDownList(this.listOptionsLinDeb, value))
    //     );
  }

  private async getListOptionLinDeb(): Promise<void> {
    await this.formularioService.getListDropDownList('sec002', 'linha_da_debulha').pipe(take(1)).toPromise().then((response: any) => {
      if (!!response?.data) {
        this.listOptionsLinDeb = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listOptionsLinDebOriginal = this.listOptionsLinDeb;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    })
  }

  private async getListOptionMotvEspDebulha(): Promise<void> {
    await this.formularioService.getListDropDownList('sec002', 'motivo_espera_debulha').pipe(take(1)).toPromise().then((response: any) => {
      if (!!response?.data) {
        this.listOptionsMotvEspDebulha = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listOptionsMotvEspDebulhaOriginal = this.listOptionsMotvEspDebulha;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    });
  }

  private async getListPeneiraTopo(): Promise<void> {
    await this.formularioService.getListDropDownList('sec002', 'peneira_topo_utilizada').pipe(take(1)).toPromise().then((response: any) => {
      if (!!response?.data) {
        this.listPeneiraTopo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listPeneiraTopoOriginal = this.listPeneiraTopo;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    })
  }

  private async getListPeneiraFundo(): Promise<void> {
    await this.formularioService.getListDropDownList('sec002', 'peneira_fundo_utilizada').pipe(take(1)).toPromise().then((response: any) => {
      if (!!response?.data) {
        this.listPeneiraFundo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listPeneiraFundoOriginal = this.listPeneiraFundo;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    })
  }

  async createFilterMotvEspDebulha(value: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listOptionsMotvEspDebulhaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listOptionsMotvEspDebulha = this.listOptionsMotvEspDebulhaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listOptionsMotvEspDebulha = this.listOptionsMotvEspDebulhaOriginal;
      }
    } else {
      this.listOptionsMotvEspDebulha = this.listOptionsMotvEspDebulhaOriginal;
    }
    // this.filterOptionsMotvEspDebulha = this.formulario.get('Motivo_espera_debulha').valueChanges
    //     .pipe(
    //         startWith(''),
    //         map(value => this.generalService._filterDropDownList(this.listOptionsMotvEspDebulha, value))
    //     );
  }

  private async createFilterListPeneiraFundo(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listPeneiraTopoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listPeneiraFundo = this.listPeneiraFundoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listPeneiraFundo = this.listPeneiraFundoOriginal;
      }
    } else {
      this.listPeneiraFundo = this.listPeneiraFundoOriginal;
    }
  }

  private async createFilterListPeneira(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listPeneiraTopoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listPeneiraTopo = this.listPeneiraTopoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listPeneiraTopo = this.listPeneiraTopoOriginal;
      }
    } else {
      this.listPeneiraTopo = this.listPeneiraTopoOriginal;
    }
  }

}
